import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initAuthFromParent } from './lib/authinit';

// Disable console logs in production
(function () {
  const isProd = window.location.hostname !== "localhost";
  if (isProd) {
    // console.log = function () {};
    // console.warn = function () {};
    // console.error = function () {};
    console.info = function () {};
    console.debug = function () {};
  }
})();

// Initialize auth from parent before rendering the app
(async () => {
  console.log("Initializing auth from parent...");
  await initAuthFromParent();
  console.log("Auth initialized, rendering app...");

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
})();
